import CustomerFullName from 'components/common/CustomerFullName';
import RelativeTime from 'components/common/RelativeTime';
import getFullVehicleName from 'helpers/vehicleFullNameHelper';
import { ChevronRight, History, HistoryIcon, User } from 'lucide-react';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

interface Props {
    recentRos: any[];
}

const RecentRos: React.FC<Props> = ({ recentRos = [] }) => {
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const id = 'ROsHistory';

    const toggleHistory = (open: boolean) => {
        if (open) {
            setIsHistoryOpen(true);
            document.addEventListener('click', onClickOutside);
        } else {
            setIsHistoryOpen(false);
            document.removeEventListener('click', onClickOutside);
        }
    };

    const onClickOutside = (e: any) => {
        const target = document.querySelector(`#${id}`);
        const withinBoundaries = e.composedPath().includes(target);

        if (withinBoundaries) {
        } else {
            toggleHistory(false);
        }
    };

    return (
        <div className="relative ">
            <button
                className={`p-2 hover:bg-slate-700 rounded transition-colors" ${isHistoryOpen ? 'bg-slate-700' : ''}`}
                onClick={() => toggleHistory(!isHistoryOpen)}
            >
                <HistoryIcon className="w-6 h-6" />
            </button>

            {isHistoryOpen && (
                <div className="absolute top-16 left-1/2 transform -translate-x-1/2 bg-white border-2 shadow-2xl w-96 rounded-lg">
                    {/* Header */}
                    <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 rounded-t-lg">
                        <div className="flex items-center justify-between">
                            <h3 className="text-lg font-semibold text-gray-600">Recently visited ROs</h3>
                        </div>
                    </div>

                    {/* RO List */}
                    <div className="max-h-96 overflow-y-auto">
                        {recentRos.map((RO, _) => (
                            <Link
                                key={RO.id}
                                to={`/repairOrder/${RO.id}`}
                                onClick={() => {
                                    toggleHistory(false);
                                }}
                            >
                                <div
                                    key={RO.number}
                                    className="px-4 py-3 border-b border-gray-100 last:border-b-0 hover:bg-blue-200 cursor-pointer transition-colors group"
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex-1 min-w-0">
                                            {/* RO Number and Status */}
                                            <div className="flex items-center space-x-2 mb-2">
                                                <span className="text-sm font-bold text-green-600 group-hover:text-green-800">
                                                    #{RO.number}
                                                </span>
                                                {RO.name && (
                                                    <span className="text-sm font-semibold text-gray-700">
                                                        {RO.name}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Vehicle Info */}
                                            <div className="flex items-center space-x-2 mb-2 group-hover:font-semibold">
                                                <div className="flex items-center space-x-1 text-gray-600">
                                                    <span className="text-sm">{getFullVehicleName(RO?.vehicle)}</span>
                                                </div>
                                            </div>

                                            {/* Customer Info */}
                                            <div className="flex items-center space-x-2 text-xs text-gray-500 group-hover:font-semibold">
                                                <User className="h-3 w-3" />
                                                <span>
                                                    <CustomerFullName
                                                        customer={RO?.customer}
                                                        customerId={RO?.customer?.id}
                                                    />
                                                </span>
                                                <span>•</span>
                                                <History className="h-3 w-3" />
                                                {RO?.dateTime && (
                                                    <span className="text-xs">
                                                        <RelativeTime dateTime={RO.dateTime} />
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="flex-shrink-0 ml-2">
                                            <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-gray-600 transition-colors" />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                        {recentRos.length === 0 && (
                            <div className="px-4 py-3 text-center text-gray-500">No recently viewed ROs.</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    recentRos: state.misc.recentlyViewedROs,
});

export default connect(mapStateToProps)(RecentRos);
